import React, { useEffect, useState } from 'react'
import Flex from 'components/shared-components/Flex'
import { useSelector } from 'react-redux'
import { Row } from 'antd'

const ErrorNoJarvislyApplication = () => {

  const [isMounted, setIsMounted] = useState(false)

  const themeColor = useSelector(state => state.theme.currentTheme)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  return (isMounted ?

      <Row justify="center" align="middle" style={{height: '100vh'}}>

        <div className={`h-100`}>
          <div className="container-fluid d-flex flex-column justify-content-between h-100 px-md-4 pb-md-4 pt-md-1">
            <div>
              <img className="img-fluid" src={`/img/${themeColor === 'light'
                ? 'logo.png'
                : 'logo-white.png'}`} alt=""/>
            </div>

            <div className="container">
              <div className="text-center mb-5">
                <img className="img-fluid"
                     style={{ maxWidth: 600 }}
                  // onLoad={() => setIsMounted(true)}
                     src="/img/others/img-21.png"
                     alt=""/>
                <h1 className="font-weight-bold mb-4">No Jarvisly Application Defined!</h1>
              </div>
            </div>

            <Flex mobileFlex={false} justifyContent="end">
            <span>
              Jarvisly Application Copyright  &copy;  {`${new Date().getFullYear()}`}
            </span>
            </Flex>

          </div>
        </div>
      </Row>
      : null
  )
}

export default ErrorNoJarvislyApplication

